import * as Yup from "yup"

export const FIELDS_NAME = {
   COLOR: "color",
}

export const initialValues = {
   [FIELDS_NAME.COLOR]: null,
}

export const validationSchema = Yup.object({
   [FIELDS_NAME.COLOR]: Yup.object().nullable().required("Color is required"),
})

export const Colors = {
   Green: "#34c38f",
   Blue: "#042d53",
   Orange: "#f97316",
   Yellow: "#f1b44c",
   White: "#ffffff",
   Black: "#000000",
   Red: "#f46a6a",
   Grey: "#cdcdcd",
   Purple: "#8b5cf6",
}
